/* eslint-disable react/no-danger */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Layout from "../components/layout/Layout";
import { themeSelector } from "../ducks/shopping/selectors";

const Container = styled.div`
  min-height: calc(100vh - 70px);
  padding: 40px;
  color: ${(props) => props.color || "black"}; // express //
`;

export default function TermsAndConditions() {

  useEffect(() => {
      window.scrollTo(0, 0);
  },[]);

  const theme = useSelector(themeSelector);

  function createMarkup() {
    return {__html: theme && theme.termsAndConditions ? theme.termsAndConditions : "<p>No se encontraron resultados<p>" };
  }

  return (
    <Layout canGoBack>
      <Container color={theme && theme.colorTitle}>
        <div className="legal-container" dangerouslySetInnerHTML={createMarkup()} />
      </Container>
    </Layout>
  );
}
